import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var Select = styled(Box).attrs(function () {
  return {
    as: "button",
    type: "button"
  };
}).withConfig({
  componentId: "sc-1pma6sa-0"
})(["cursor:pointer;"]);
var SelectCaret = styled("span").withConfig({
  componentId: "sc-1pma6sa-1"
})(["position:absolute;top:0;right:0;bottom:0;padding:0 ", ";display:flex;place-items:center;pointer-events:none;"], spacing("md"));
export { Select, SelectCaret };